export const GENERAL_SCHEDULE_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/scheduleschema.json' as const;
export const GENERAL_SCHEDULE_COMPONENT_TYPE = 'GeneralSchedule' as const;
